import React, { Component } from "react";
import ThisTable from "components/Common/ThisTable/index";
import { languageService } from "../../../../Language/language.service";
import { ButtonActionsTable } from "../../../Common/Buttons";
class AlertsList extends Component {
  constructor(props) {
    super(props);

    this.alertsListColumn = [
      // {
      //   id: "alertType",
      //   Header: "Type",
      //   minWidth: 100,
      //   accessor: (d) => d.alertType,
      // },
      {
        id: "expiryAlertDays",
        Header: languageService("Alert Days"),
        minWidth: 100,
        accessor: (d) => {
          return <div style={{ textAlign: "center" }}>{d.expiryAlertDays} </div>;
        },
      },
      {
        id: "emailUserIds",
        Header: languageService("Users"),
        minWidth: 350,
        accessor: (d) => {
          let userFilter = [];
          this.props.userList && (userFilter = this.props.userList.filter((user) => d.emailUserIds.find((uId) => uId === user._id)));
          let stringVal = "";
          userFilter.map((user, index) => {
            stringVal += `${index === 0 ? "" : ", "}${user.name} `;
          });
          return (
            <span
              style={{
                textOverflow: "ellipsis",
                overflow: "hidden",
                height: "17px",
                display: "inline-block",
                whiteSpace: "nowrap",
              }}
            >
              {stringVal}
            </span>
          );
        },
      },
      {
        Header: languageService("Actions"),
        id: "actions",
        accessor: (d) => {
          return (
            <div>
              <ButtonActionsTable
                handleClick={() => {
                  this.props.editAlert(d);
                }}
                margin="0px 10px 0px 0px"
                buttonText={languageService("Edit")}
              />
              <ButtonActionsTable
                handleClick={() => {
                  this.props.deleteAlert(d.id);
                }}
                margin="0px 10px 0px 0px"
                buttonText={languageService("Delete")}
              />
            </div>
          );
        },
        minWidth: 120,
      },
    ];
  }
  render() {
    return (
      <div>
        <ThisTable
          tableColumns={this.alertsListColumn}
          tableData={this.props.testAlerts}
          pageSize={7}
          minRows={1}
          pagination={true}
          height={"auto"}
        />
      </div>
    );
  }
}

export default AlertsList;



// WEBPACK FOOTER //
// ./src/components/SetupPage/GITestAssetTypes/AddAlerts/AlertsList.jsx